module.exports = __webpack_public_path__ + "img/header_logo.f4cb36f9.png";